import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild, } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import configura from '../../../assets/config.json';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';
import * as XLSX from 'xlsx';
import {formatDate} from '@angular/common';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSelectChange } from "@angular/material/select";
declare function loadRequiredFiles(a: string): any;
declare function generateDashboard(
  dashbboardid: string,
  dashboardtype: string,
  dashboarddivid: string,
  username: string,
  psd: string
): any;


@Component({
  selector: 'app-ibos360-dashboard-infographical',
  templateUrl: './ibos360-dashboard-infographical.component.html',
  styleUrls: ['./ibos360-dashboard-infographical.component.css']
})
export class Ibos360DashboardInfographicalComponent implements OnInit {

  lstScript = [];
  // dashboardId360: string = 'rc6o1yyPYKdEhc6J47juCsXnJwOF26FGqFm%2BDzFmF5%2BjeWRGwDMo%2FA1W%2BG06XxYjNP2HvA%3D%3D';
  // dashboardType360: string = 'QBDGCswWD7V4S8QUbsM0uPLgrIAxcyws7R8DUXu98KVTeFONpmfcjt3d8Enrs5QXQgSBng%3D%3D';
  reporttypeselected='reporttypeselected';
  dashboardId360: string = '';
  dashboardType360: string = '';
  is_projectName: string = "NA";
  subscription: any;
  report_360_src: string = configura.report_360_src;
  lstreportType:any=[];   // Added by kavitha 11/02/2026
  lstchangeQueuereporttype:any=[]; // Added by kavitha 11/02/2026
  report_type_id: number = 0;
  report_type_name:string='';
  frmControlPanel: FormGroup;
  
  //report_360_src: string = '';
  loadRequiredFiles_PATH: string = "";
  

// constructor(private dataService: DataService, public commonService: CommonService,
//     private route: Router, private modalService: NgbModal, private encryptDecryptservice: EncryptDecryptService,private memorystore: MemoryStorageService) {
//     if (route.getCurrentNavigation().extras.state != undefined) {
//       //this.backflag = true;
//     }
//   }


  constructor(
    private elementRef: ElementRef,
    public commonService: CommonService,
    private route: Router,
    private dataService: DataService,
    private encryptDecryptservice: EncryptDecryptService,
    private memorystore: MemoryStorageService
  ) {

    this.lstScript = [
      {
        sriptName: 'generateservice',
        src: this.report_360_src,
        // src: 'http://10.251.233.4:8024/assets/js/generateservice.js',

      },
    ];
    //src: 'http://192.168.10.81:8007/assets/js/generateservice.js',
    //src: 'http://10.251.230.132:8047/assets/js/generateservice.js',
    // Subscribe Emmiter Service from Sidebar Component Typescript file when click on other VB menus and emit.
    this.subscription = EmmiterService.get('load360Dashboard').subscribe(
      (res) => {
        // this.loadDashboardOrReport();
        this.get_integration_360_report_configuration();
        this.loadDashboardOrReport_fromdb();
      }
    );
  }


  async ngOnInit(): Promise<void >{
    //this.loadDashboardOrReport();
    const formControls: any = {};
    formControls['reporttypeselected'] = new FormControl(0, []);
    this.frmControlPanel = new FormGroup(formControls);
    this.get_integration_360_report_configuration();
    this.loadDashboardOrReport_fromdb();
    await this.bindReportTypes(); //Added by kavitha 11/02/2026
  }
  async bindReportTypes() {
    this.lstreportType = [];
    let params = new HttpParams();
    params = params.append('role_id', this.commonService.selectedRole);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('user_id', this.memorystore.getItem('userId'));
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));

    await this.dataService.getDataPromise('controlpanel-Report-types', params).then(res => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res != null && res.data != null) {
          this.lstreportType = res.data;
          // for (var i = 0; i < this.lstDocumentType.length; i++) {
          //   if (this.document_type_id == this.lstDocumentType[i].document_type_id) {
          //     debugger;
          //     this.total = this.lstDocumentType[i].tot_idea;
          //     this.getmyideas = this.lstDocumentType[i].my_idea;
          //     this.implementableideas = this.lstDocumentType[i].implementable_ideas;
          //   }
          // }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }

    },
      error => {
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      })

  }
  async exportexcel()
    {{
      this.report_type_id = this.frmControlPanel.get('reporttypeselected').value;
      this.report_type_name ;//= reporttype.source.value;
      // alert(this.report_type_name);
      this.lstchangeQueuereporttype = [];
      let params = new HttpParams();
      params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
      params = params.append('user_id', this.memorystore.getItem('userId'));
      params = params.append('report_id',this.report_type_id);
      params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));

      await this.dataService.getDataPromise('controlpanel-Reportwise-types', params).then(res => {
        if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
         
          if (res != null && res.data != null) {
            this.lstchangeQueuereporttype = res.data;
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
  
      },
        error => {
          if (error.includes("401")) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
        })
      
          // if (this.lstchangeQueuereporttype != null) {
          //   this.lstchangeQueuereporttype.forEach(column => {
              
          //   });
          // }
          // if (this.lstchangeQueuereporttype != null) {
          //   this.lstchangeQueuereporttype.forEach(column => {
              
          //   });
          // }
          //this.lstchangeQueuereporttype.push(obj);
          if (this.lstchangeQueuereporttype != null) {
          const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.lstchangeQueuereporttype);
          const wb: XLSX.WorkBook = XLSX.utils.book_new();
      
          XLSX.utils.book_append_sheet(wb, ws, 'LoadDataSheet');
      
          //const ws_master: XLSX.WorkSheet = XLSX.utils.json_to_sheet(master_data); //master data
          //ws_master['!protect'] = { selectLockedCells: false, autoFilter: false, formatColumns: false }; //master data
          //XLSX.utils.book_append_sheet(wb, ws_master, 'MasterData'); //master data
      
         // XLSX.writeFile(wb, this.report_type_name  +  new  Date().getTime() + '.xlsx');
          XLSX.writeFile(wb, this.report_type_name +'_'  +  formatDate(new Date(), 'dd/MM/yyyy', 'en') +'_'+formatDate(new Date(), 'hh:mm:ss', 'en')+ '.xlsx');
          }
        
    }}
  
  async changeQueuereporttype(reporttype:MatSelectChange) {
    this.report_type_id= this.frmControlPanel.get('reporttypeselected').value;
    this.report_type_name = reporttype.source.triggerValue;
    this.lstchangeQueuereporttype = [];
    let params = new HttpParams();
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('user_id', this.memorystore.getItem('userId'));
    params = params.append('report_id',this.report_type_id);
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));

    await this.dataService.getDataPromise('controlpanel-Reportwise-types', params).then(res => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res != null && res.data != null) {
          this.lstchangeQueuereporttype = res.data;
          // for (var i = 0; i < this.lstDocumentType.length; i++) {
          //   if (this.document_type_id == this.lstDocumentType[i].document_type_id) {
          //     debugger;
          //     this.total = this.lstDocumentType[i].tot_idea;
          //     this.getmyideas = this.lstDocumentType[i].my_idea;
          //     this.implementableideas = this.lstDocumentType[i].implementable_ideas;
          //   }
          // }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }

    },
      error => {
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      })
  }

  get_integration_360_report_configuration() {

    this.dashboardId360 = '';
    this.dashboardType360 = '';
    this.loadRequiredFiles_PATH = '';
    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    this.dataService.getDataPromise('get_integration_360_report_configuration', params).then(res => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != null && res.data != null) {
          this.dashboardId360 = res.data[0].report_dashboardid;
          this.dashboardType360 = res.data[0].report_dashboardtype;
          this.loadRequiredFiles_PATH = res.data[0].loadrequiredfiles_path;
          debugger;
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }

    },
      error => {
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      })
  }

  loadDashboardOrReport_fromdb() {

    this.commonService.showHideLoader(true);
    this.lstScript.forEach((s) => {
      this.loadJS(s.src).onload = (ev) => {
        loadRequiredFiles(this.loadRequiredFiles_PATH);
        if (
          this.dashboardId360 != null &&
          this.dashboardId360 != undefined &&
          this.dashboardId360 != '' &&
          this.dashboardType360 != null &&
          this.dashboardType360 != undefined &&
          this.dashboardType360 != ''
        ) {
          generateDashboard(
            this.dashboardId360,
            this.dashboardType360,
            'divcontainer',
            'tcs',
            'tcs'
          );
        }
      };
    });

    this.commonService.showHideLoader(false);
  }

  loadDashboardOrReport() {
    this.commonService.showHideLoader(true);

    this.lstScript.forEach((s) => {
      this.loadJS(s.src).onload = (ev) => {
        // loadRequiredFiles('http://192.168.10.81:8007');  
        // this.is_projectName = this.commonService.getUserInfoFromLocalStorage('projectName');
        this.is_projectName = this.memorystore.getItem('projectName');
        if (this.is_projectName == "Al Maya - PI IDEAS") {
          // this.dashboardId360  = 'rc6o1yyPYKdEhc6J47juCsXnJwOF26FGqFm%2BDzFmF5%2BjeWRGwDMo%2FA1W%2BG06XxYjNP2HvA%3D%3D';
          // this.dashboardType360  = 'QBDGCswWD7V4S8QUbsM0uPLgrIAxcyws7R8DUXu98KVTeFONpmfcjt3d8Enrs5QXQgSBng%3D%3D';
          this.dashboardId360 = '8eiGWlnb3Z7Mek7qwOv5AiUrk70rxH8Tj5U5r%2FYekOJM3FZU6QkQ1CC3shx8Dcx%2BNggrqQ%3D%3D';
          this.dashboardType360 = 'X1t2eIKqPSxiBVcTUw7avuswXfeYaM0gmdbB7dOErzcOAFNJTg1IN%2FOQCzSkr4d8Fv%2BBOg%3D%3D';
        }
        else if (this.is_projectName == "PI IDEAS") {
          this.dashboardId360 = 'KURqCVS%2BOSnM2J9XPJJsOjXnK1MGxuFdxPoq5t73OeBAJuhYInInQ%2FpbrLtLbPB%2B1aYrqQ%3D%3D';
          this.dashboardType360 = '0pNV1D2rmwsiZVTyTbYIeYcxYMm0OqHTR7lMKRUYDvt%2BrzCwvUvK%2FjretxIvtIkxNk%2F4qw%3D%3D';
        }
        else if (this.is_projectName == "Al Maya - AP") {
          // this.dashboardId360  = '0e0%2FYWbDzt%2FxONxBVprd57mY24eKe9%2BcVnZ1XU%2BlVNbB78sJ9KaWPz28xNx%2BKT1vUj3Crg%3D%3D'
          // this.dashboardType360  = 'aOYCjN%2BK2VO3q8S4sK1xCDulGZ0ckz2jN3kw%2Fy2c3lfyGKnufn9NGvoC5D0vXTNs1fCv6w%3D%3D';
          this.dashboardId360 = '%2BGQSU8L%2FsXzYHoASYZUGeUjhhTJ6S5w7J%2BgXTmqXzkLDKsOKGgxNUjz4waNQWyIscyE7ug%3D%3D'
          this.dashboardType360 = 'D1vraVK%2FUpPmQbEOvX5hFrroWau8AX3%2Bke9Q5CrtpWnQ0DGMxIaHeTUcZOSP8AMYKaSzTg%3D%3D';

        }
        else if (this.is_projectName == "Al Maya - AR") {
          this.dashboardId360 = ''
          this.dashboardType360 = '';

        }
        else if (this.is_projectName == "Al Maya - PNL") {
          this.dashboardId360 = ''
          this.dashboardType360 = '';

        }
        else if (this.is_projectName == "Al Maya - Help Desk") {
          this.dashboardId360 = ''
          this.dashboardType360 = '';

        }
        else if (this.is_projectName == "Doa workflow") {
          this.dashboardId360 = ''
          this.dashboardType360 = '';

        }
        else {
          this.dashboardId360 = 'u0tdoAPEomhdCeJkgOGul7EA8RcqfBbzSMI9lnCdFZeY5a5S5BEH2mhxrcks0VBz8iwsyw%3D%3D';
          this.dashboardType360 = 'NnzBhI9zt%2BXK4rkPYd%2BeUoMcFkOWPjBMeb14auGJoLQ8Q6CMurHU3KqOhjS3aoXLk2lvCQ%3D%3D';

        }

        // loadRequiredFiles('http://10.251.230.132:8047'); 
        // loadRequiredFiles('http://10.251.233.4:8024');

        if (
          this.dashboardId360 != null &&
          this.dashboardId360 != undefined &&
          this.dashboardId360 != '' &&
          this.dashboardType360 != null &&
          this.dashboardType360 != undefined &&
          this.dashboardType360 != ''
        ) {
          debugger;
          generateDashboard(
            this.dashboardId360,
            this.dashboardType360,
            'divcontainer',
            'tcs',
            'tcs'
          );
        }
      };
    });

    this.commonService.showHideLoader(false);
  }

  loadJS(src: string): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.nonce = "cd90d3070658eb370a6e152dc25dc04f";
    // if (self === top) {
    //   var antiClickjack = document.getElementById("antiClickjack");
    //   antiClickjack.parentNode.removeChild(antiClickjack);
    // } else {
    //   //top.location = self.location;
    // }
    this.elementRef.nativeElement.appendChild(script);
    return script;
  }
}
